import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installGlobalErrorHandlers } from './utils/globalErrorHandlers';
import reportWebVitals from './reportWebVitals';
import { listenForInstallPrompt } from './phone/installPrompt';

// Before render: Chrome may fire its install offer early, and a missed event
// cannot be recovered (ROADMAP "Add IndexAlpha to the home screen").
listenForInstallPrompt();

// Capture uncaught errors + unhandled promise rejections (outside React's
// render tree) into Cloud Logging. See ARCHITECTURE.md §14 (application layers).
installGlobalErrorHandlers();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// LCP / INP / CLS per device class, for phone-vs-desktop ranking data.
reportWebVitals();
